// ¿Esta direccion o telefono de un selector es el que tiene la orden?
// `current` es la direccion de la orden (camelCase, como llega del API):
// infoautoAddressId, infoautoPhoneId, street1, postalCode, phone.

const digits = value => String(value || "").replace(/\D/g, "");
const text = value =>
  String(value || "")
    .trim()
    .toLowerCase();

// Las de Infoauto por id; las web (sin id) por calle y codigo postal
export function isOrderAddress(address, current) {
  if (!address || !current) return false;
  if (current.infoautoAddressId) {
    return (
      String(address.infoautoAddressId || "") ===
      String(current.infoautoAddressId)
    );
  }
  if (address.infoautoAddressId) return false;
  return (
    !!text(current.street1) &&
    text(address.street1) === text(current.street1) &&
    digits(address.postalCode) === digits(current.postalCode)
  );
}

// Por id de Infoauto; si la orden no lo tiene, por numero (el de la orden
// puede venir con el codigo de area pegado)
export function isOrderPhone(phone, current) {
  if (!phone || !current) return false;
  if (current.infoautoPhoneId) {
    return (
      String(phone.infoautoPhoneId || "") === String(current.infoautoPhoneId)
    );
  }
  const number = digits(phone.number);
  return !!number && digits(current.phone).endsWith(number);
}

// La de la orden primero
export function orderFirst(items, isCurrent) {
  return [...items].sort((a, b) => isCurrent(b) - isCurrent(a));
}
